import React from 'react';
import cx from 'classnames';

import { gravatar } from '../../internals/user';

// @ts-ignore
import DefaultAvatar from '../../images/avatar.svg';

export const UserAvatar: React.FC<{
  className?: string;
  email?: string;
  title?: string;
  showDefault: boolean;
  handleError: () => void;
}> = ({ className, email, title, showDefault, handleError }) => {
  if (!email) {
    return null;
  }

  const allClasses = cx('user-avatar', className);
  const alt = 'User profile avatar';

  return showDefault ? (
    <DefaultAvatar alt={alt} className={allClasses} />
  ) : (
    <img
      alt={alt}
      className={allClasses}
      onError={handleError}
      src={gravatar(email)}
      title={title}
    />
  );
};
